import { j as s } from "./index.es176.js";
const t = ({
  headingLevel: r = 2,
  isGroupHeader: e = !1,
  ...a
}) => {
  const h = (() => {
    switch (r) {
      case 0:
        return e ? "h1" : "h2";
      case 2:
        return e ? "h2" : "h3";
      case 3:
        return e ? "h3" : "h4";
      case 4:
        return e ? "h4" : "h5";
      case 5:
        return e ? "h5" : "h6";
      default:
        return e ? "h2" : "h3";
    }
  })();
  return /* @__PURE__ */ s.jsx(
    h,
    {
      className: `bd-accordion-header__header-tag ${a.className}`,
      ...a,
      children: a.children
    }
  );
};
export {
  t as default
};
//# sourceMappingURL=index.es435.js.map
